//** Component  */
import React from "react";

//** Lib */

import ProductImport from "./ProductImport";
import RequestOperationalModuleListTab from "../../styles/RequestOperationalModuleListTab";
import { hasFunctionalPermission } from "../../utils/AuthorizeNavigation/authorizeNavigation";
import { securityKey } from "../../navigation/SecurityKey";
import CustomTab from "../../components/common/RenderTab/CustomTab";


function ProductImportList() {

  const hasOpenTabPermission = hasFunctionalPermission(securityKey.PRODUCTIMPORTOPENTAB);
  const hasArchiveTabPermission = hasFunctionalPermission(securityKey.PRODUCTIMPORTARCHIVETAB);

  const data = [
    {
      id: "1",
      tabTitle: "Open",
      tabContent: <ProductImport openStatus={1} />,
      isVisible: hasOpenTabPermission?.hasAccess,
    },
    {
      id: "2",
      tabTitle: "Archive",
      tabContent: <ProductImport openStatus={2} />,
      isVisible: hasArchiveTabPermission?.hasAccess,
    },
  ];

  return (
    <>
        <CustomTab data={data} />
    </>
  );
}

export default ProductImportList;
